import MyTeamLeaveCalendar from "../components/MyTeamLeaveCalendar";
import useMyTeamLeaveCalendar from "../hooks/useMyTeamLeaveCalendar";

function MyTeamLeaveCalendarPage() {
    const useMyTeamLeaveCalendarProps = useMyTeamLeaveCalendar();
    return (
        <MyTeamLeaveCalendar {...useMyTeamLeaveCalendarProps} />
    )
}
export default MyTeamLeaveCalendarPage;